export const springHover = { type: 'spring', stiffness: 300, damping: 22 };
